import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormDiamond: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-diamond, square-45-degrees"><path d="M10.7625 2.17698C11.4459 1.49366 12.5537 1.49366 13.2371 2.17698L21.823 10.7629C22.5061 11.4463 22.5063 12.5542 21.823 13.2375L13.2371 21.8235C12.5538 22.5067 11.4459 22.5066 10.7625 21.8235L2.17655 13.2375C1.49323 12.5541 1.49323 11.4463 2.17655 10.7629L10.7625 2.17698Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormDiamond;
